import { render, staticRenderFns } from "./NotesByAdmin.vue?vue&type=template&id=3c3cd283&scoped=true"
import script from "./NotesByAdmin.vue?vue&type=script&lang=js"
export * from "./NotesByAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3cd283",
  null
  
)

export default component.exports